import { DOC_SAVING_FAILED, DOC_SAVING_SUCCESSED } from "./types";

export const saveDocBody = (inputs) => (dispatch) => {
	try {
		dispatch({
			type: DOC_SAVING_SUCCESSED,
			payload: inputs,
		});
	} catch (e) {
		dispatch({
			type: DOC_SAVING_FAILED,
		});
	}
};
